"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssTextRestVar = exports.cssBaseTextVar = exports.cssBaseBorderVar = exports.cssBaseBackgroundVar = exports.cssBackgroundRestVar = exports.cssBackgroundHoverVar = exports.cssBackgroundActiveVar = exports.BUTTON_STYLE_PROPERTIES_BY_SIZE_MAP = void 0;
const LARGE_BUTTON = {
  height: 40,
  fontSize: 14
};
const MEDIUM_BUTTON = {
  height: 32,
  fontSize: 13
};
const SMALL_BUTTON = {
  height: 24,
  fontSize: 13
};
const XSMALL_BUTTON = {
  height: 20,
  fontSize: 13
};

// These are only used in tests, and only reflect Lodestar sizing.
const BUTTON_STYLE_PROPERTIES_BY_SIZE_MAP = {
  large: LARGE_BUTTON,
  medium: MEDIUM_BUTTON,
  small: SMALL_BUTTON,
  xsmall: XSMALL_BUTTON
};
exports.BUTTON_STYLE_PROPERTIES_BY_SIZE_MAP = BUTTON_STYLE_PROPERTIES_BY_SIZE_MAP;
const cssBaseBackgroundVar = "--sds--button--color--background";
exports.cssBaseBackgroundVar = cssBaseBackgroundVar;
const cssBackgroundRestVar = "--sds--button--color--background--rest";
exports.cssBackgroundRestVar = cssBackgroundRestVar;
const cssBackgroundHoverVar = "--sds--button--color--background--hover";
exports.cssBackgroundHoverVar = cssBackgroundHoverVar;
const cssTextRestVar = "--sds--button--color--text--rest";
exports.cssTextRestVar = cssTextRestVar;
const cssBaseTextVar = "--sds--button--color--text";
exports.cssBaseTextVar = cssBaseTextVar;
const cssBaseBorderVar = "--sds--button--color--border";
exports.cssBaseBorderVar = cssBaseBorderVar;
const cssBackgroundActiveVar = "--sds--button--color--background--active";
exports.cssBackgroundActiveVar = cssBackgroundActiveVar;
//# sourceMappingURL=constants.js.map